import React from 'react';
import { forwardRef } from 'react';
import { cn } from '@/lib/utils';
import ResponsiveWrapper from '@/components/layout/ResponsiveWrapper';
import type { SpacerProps } from './types';

const Spacer = forwardRef<HTMLDivElement, SpacerProps>(
  (
    {
      size = 'h-4',
      direction = 'vertical',
      responsive = {},
      className = '',
      ...props
    },
    ref,
  ) => {
    const classes = cn(
      direction === 'vertical' ? size : size.replace('h-', 'w-'),
      className,
    );

    return (
      <ResponsiveWrapper responsive={responsive}>
        <div
          id="SPACER"
          ref={ref}
          className={classes}
          {...props}
          aria-hidden="true"
        />
      </ResponsiveWrapper>
    );
  },
);

Spacer.displayName = 'Spacer';

export default React.memo(Spacer);
